module.exports = __webpack_public_path__ + "static/media/fresco_logo.a5a5ef41.png";